import { urlAxios } from '../utils/interceptor';




export const getEstylist = async () => {
    try {
        const response = await urlAxios.get("estilistas.json");
        for (let key in response.data) {
            response.data[key].id = key;
        }
        const responseArray = Object.values(response.data).reverse()
        return responseArray;
    } catch (error) {
        throw error;
    }
};

export const postEstylist = async (datos) => {
    try {
        const response = await urlAxios.post(`estilistas.json?auth=${localStorage.getItem('token')}`, datos);

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateEstylist = async (id, data) => {

    try {
        const response = await urlAxios.patch(`estilistas/${id}.json?auth=${localStorage.getItem('token')}`,data)
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteEstylist = async (id) => {
    try {
        const response = await urlAxios.delete(`estilistas/${id}.json?auth=${localStorage.getItem('token')}`);
        return response;
    } catch (error) {
        throw error;
    }
};
